// @flow
import React from 'react';
import { Trans } from 'react-i18next';

import Tariff, { FreeTariff } from 'app/components/Tariff';
import TariffModal from 'app/components/Subs/TariffModal';
import TariffsList from 'app/components/Subs/TariffsList';
import PriceDiscounted, { priceTypes } from 'app/components/Tariff/PriceDiscounted';

import enhanceTariffInfo from './enhanceTariffInfo';
import styles from './TariffInfo.scss';


type Props = {
  studentId: string,
  service: string,
  tariffName: string,
  isFrozen: boolean,
  tariffCost: string,
  close: (e: SyntheticEvent<HTMLElement>) => void,
  openTariffInfo: (e: SyntheticEvent<HTMLElement>) => void,
  openAllTariffs: (e: SyntheticEvent<HTMLElement>) => void,
  showTariff: boolean,
  showAllTariffs: boolean,
  appName: string,
  subId: string,
  t: (s: string, t: Object) => string,
  tariffId?: number,
  tariffBundleId?: number,
};

const TariffInfo = ({
  studentId,
  service,
  tariffName,
  isFrozen,
  tariffCost,
  close,
  showTariff,
  showAllTariffs,
  openTariffInfo,
  openAllTariffs,
  appName,
  subId,
  t,
  tariffId,
  tariffBundleId,
}: Props) =>
  <div className={styles.root}>
    <div className={styles.row}>
      <div>
        <Trans i18nKey="subs:column_name_tariff">
          Тариф
        </Trans>
        &nbsp;
        {isFrozen
          && <span className={styles.frozen}>
            <Trans i18nKey="subs:tariff_paused_warning">
              действие приостановлено
            </Trans>
          </span>}
      </div>
      {tariffCost && <div className={styles.cost}>
        <Trans i18nKey="subs:column_name_cost">
          Стоимость
        </Trans>
      </div>}
    </div>
    <div className={styles.row}>
      <div>
        <div className={styles.name}>{tariffName}</div>
      </div>
      {tariffCost && <div className={styles.cost}>
        <div className={styles.value}>
          {subId
            ? <PriceDiscounted
              studentId={parseInt(studentId, 10)}
              tariffId={tariffId}
              tariffBundleId={tariffBundleId}
              priceType={priceTypes.price_base}
            />
            : tariffCost}
          {/* old {tariffCost} */}
        </div>
      </div>}
    </div>
    <div className={styles.row}>
      <a href="more" className={styles.link} onClick={openTariffInfo}>
        <Trans i18nKey="subs:tariff_info_link">
          Подробнее о тарифе
        </Trans>
      </a>
      <a href="list" className={styles.rightalignedlink} onClick={openAllTariffs}>
        <Trans i18nKey="subs:tariff_list_link">
          Сменить тариф
        </Trans>
      </a>
    </div>
    {showTariff
      && <TariffModal
        title={t('tariff_info_title')}
        description={t('tariff_info_description', { appName })}
        close={close}
      >
        {subId
          ? <Tariff
            subId={subId}
            studentId={parseInt(studentId, 10)}
            service={service}
            close={close}
          />
          : <FreeTariff
            service={service}
          />}
      </TariffModal>}
    {showAllTariffs
      && <TariffModal
        title={t('tariff_list_title')}
        description={t('tariff_list_description', { appName })}
        close={close}
      >
        <TariffsList
          service={service}
          studentId={studentId}
          currentSubId={subId}
          close={close}
        />
      </TariffModal>
    }
  </div>;

export default enhanceTariffInfo(TariffInfo);
